import React, {Component} from "react";
import HttpRequest from "../../../HttpRequest";
import Loader from "../../../components/Loader";
import ErrorPage from "../../../components/ErrorPage";
import Route from "../../../Route";
import {Tools} from "../../../Tools";
import Link from "../../../components/Link";


const loadingInButtonLabel = (
    <>
        <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"/>
        Loading...
    </>
),
applicationsButtons = {
    createAccount: {
        type: "a",
        className: "btn btn-default",
        href: "#",
        label: "Créer le compte",
        attributes: {
            "member" : "",
            "data-name" : "createAccount",
        },
        handleClick: null,
    },
    lockAccount: {
        type: "a",
        className: "btn btn-danger",
        href: "#",
        label: "Bloquer le compte",
        attributes: {
            "member" : "",
            "data-name" : "lockAccount",
        },
        handleClick: null,
    },
    unlockAccount: {
        type: "a",
        className: "btn btn-success",
        href: "#",
        label: "Débloquer le compte",
        attributes: {
            "member" : "",
            "data-name" : "unlockAccount",
        },
        handleClick: null,
    },
    resetPassword: {
        type: "a",
        className: "btn btn-primary",
        href: "#",
        label: "Réinitialiser le mot de passe",
        attributes: {
            "member" : "",
            "data-name" : "resetPassword"
        },
        handleClick: null,
    },
};

/**
 * Application is refer to demande d'adhésion in french
 */
class MembersAccounts extends Component{
    constructor(props){
        super(props);
        this.handleButtonClicked = this.handleButtonClicked.bind(this);

        this.httpClient = new HttpRequest();
        this.state = {
            server: {},
            isLoadCompleted: false,
            hasPageError: false,
            hasError: false,
            applicationsButtons: applicationsButtons
        };
        this.query = {};
    }

    handleButtonClicked(event){
        event.preventDefault();
        const
            currentTarget = event.target,
            name = currentTarget.getAttribute("data-name")
        ;
        let
            method = name === "createAccount" ? "POST" : "PATCH",
            member = currentTarget.getAttribute("member")
        ;

        if(applicationsButtons.hasOwnProperty(name) && member){
            member = Tools.StringToJson(member);
            const members = this.state.members,
                index = Tools.GetItemIndex("slug", member.slug, members),
                memberItem = members[index]
            ;


            let buttons = Tools.Clone(memberItem.buttons);
            buttons[name].label = loadingInButtonLabel;
            buttons[name].attributes = {...buttons[name].attributes, disabled: true};
            members[index].buttons = buttons;
            Object.keys(members[index].buttons).forEach((buttonName) => {
                if(buttonName !== name){
                    members[index].buttons[buttonName].attributes.disabled = true;
                }
            });
            this.setState({members: members});

            // Async method
            this.setApplication(method, {
                id: member.id,
                buttonAction: name
            });
        }
    }

    render() {
        let element = <h3 className="">Aucune demande d'adhésion en attente de validation.</h3>
        if(!this.state.isLoadCompleted){
            element = <Loader />;
        }
        else if(this.state.hasError){
            const text = this.state.server && this.state.server.message ? "<h1>"+ this.state.server.message +"</h1>" : "";
            element = <ErrorPage data={{content: text}} />;
        }
        else{
            if(!Tools.IsEmpty(this.state.members)){
                element = this.state.members.map((member) => {
                    return (
                        <div key={member.slug} className="row mb-4">
                            <div className="col-md-2">
                                <img src={Route.APIBaseUrl + Route.APILoadMemberFile + member.avatar} className="img-thumbnail img-responsive" alt={member.name + " avatar"} width="150" />
                            </div>
                            <div className="col-md-6 paragraph ">
                                <h4>{member.civility + ". " + member.name.toUpperCase() + " " + member.firstName}</h4>
                                <div>Cycle : <strong>{member.cycle.toUpperCase()}, </strong>{member.hasFinishedCycle ? "a" : "n'a pas" } terminé son cycle</div>
                                <div>Promotion : <strong>{member.promotion}</strong></div>
                                <div>Email : <strong>{member.email}</strong></div>
                                <div className="mt-6">
                                    {
                                        member.actionMessage ? <div><strong className="label label-success mt-3">{member.actionMessage}</strong></div> : ""
                                    }
                                </div>
                            </div>
                            <div className="col-md-3">
                                {
                                    member.password ?
                                        <>
                                            <Link data={member.buttons.resetPassword} />
                                            <br/>
                                            <br/>
                                            <Link data={member.isLocked ? member.buttons.unlockAccount : member.buttons.lockAccount} />
                                        </>
                                        :
                                        <>
                                            <br/>
                                            <Link data={member.buttons.createAccount} />
                                        </>
                                }
                            </div>
                        </div>
                    );
                });
                element = (
                    <>
                        <h3 className="">{this.state.members.length} compte(s) utilisateur.</h3>
                        <br/>
                        {element}
                    </>
                );
            }
        }

        return element;
    }


    componentDidMount() {
        this.loadApplications();
    }

    componentWillUnmount() {
        this.httpClient.cancelRequest();
    }

    loadApplications() {
        this.setApplication("GET");
    }

    setApplication(method, body = null){
        const _self = this;
        let url = Route.APIMembersAccounts;
        if(body && body.buttonAction && body.id){
            switch (body.buttonAction) {
                case applicationsButtons.createAccount.attributes["data-name"]:
                    url = Route.APIMembersAccountsCreate;
                    break;
                case applicationsButtons.lockAccount.attributes["data-name"]:
                    url = Route.APIMembersAccountsLock;
                    break;
                case applicationsButtons.unlockAccount.attributes["data-name"]:
                    url = Route.APIMembersAccountsLock;
                    break;
                case applicationsButtons.resetPassword.attributes["data-name"]:
                    url = Route.APIMembersAccountsReset;
                    break;
            }
            url = url.replace("{id}", body.id);
        }
        this.httpClient.request(url, method, {}, body ? body : {}).then(function (response){
            _self.server = response;
            _self.setState(response.code === 200 ? _self.buildData(response.data) : {server: response, isLoadCompleted: true, hasError: true});
        }).catch(function (error){
            _self.server = error;
            _self.setState({server: error, hasError: true });
        });
    }

    buildData(data){
        const _self = this,
            members = data.members.map((member) => {
            member.buttons = {
                createAccount: {
                    ..._self.state.applicationsButtons.createAccount,
                    attributes: {..._self.state.applicationsButtons.createAccount.attributes, member: Tools.JsonToString(member)},
                    handleClick: _self.handleButtonClicked
                },
                lockAccount: {
                    ..._self.state.applicationsButtons.lockAccount,
                    attributes: {..._self.state.applicationsButtons.lockAccount.attributes, member: Tools.JsonToString(member)},
                    handleClick: _self.handleButtonClicked
                },
                unlockAccount: {
                    ..._self.state.applicationsButtons.unlockAccount,
                    attributes: {..._self.state.applicationsButtons.unlockAccount.attributes, member: Tools.JsonToString(member)},
                    handleClick: _self.handleButtonClicked
                },
                resetPassword: {
                    ..._self.state.applicationsButtons.resetPassword,
                    attributes: {..._self.state.applicationsButtons.resetPassword.attributes, member: Tools.JsonToString(member)},
                    handleClick: _self.handleButtonClicked
                }
            };
            return {...member};
        });
        return {
            hasError: false,
            isLoadCompleted: true,
            members: members,
            isTableRowLoadCompleted: true,
        };
    }
}

export default MembersAccounts;